import DocumentosService from "../api/Documentos/api-documentos";
import fileDownload from "js-file-download";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { PDF_MG, PDF_CW } from "./pdfPage";

export const DownloadFile = async (documentoURL) => {
    const data = await DocumentosService.consultarArchivo(documentoURL);
    fileDownload(data.data, documentoURL);
}

export const DownloadHTML = (html: any) => {
    html2canvas(html)
      .then((canvas) => {
        // Mismos márgenes (30 mm) que el resto de documentos que genera la plataforma
        let imgWidth = PDF_CW;
        let imgHeight = canvas.height * imgWidth / canvas.width;
        const imgData = canvas.toDataURL('img/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        pdf.addImage(imgData, 'PNG', PDF_MG, PDF_MG, imgWidth, imgHeight);
        pdf.save("download.pdf");
      })
    ;
}